import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FormFieldComponent,
} from '../../shared/form-field/form-field.component';
import {
  ReorderAction,
  ReorderButtonsComponent,
} from '../reorder-buttons/reorder-buttons.component';

import { TrashButtonComponent } from '../trash-button/trash-button.component';

@Component({
  selector: 're-speed-and-distance-op',
  templateUrl: './speed-and-distance-op.component.html',
  styleUrl: './speed-and-distance-op.component.css',
  imports: [
    FormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    ReorderButtonsComponent,
    TrashButtonComponent,
  ],
})
export class SpeedAndDistanceOpComponent {
  @Input({ required: true }) action: any;

  fieldType: typeof FieldType = FieldType;

  @Output() delete = new EventEmitter<any>();
  @Output() reorder = new EventEmitter<{ id: number; action: ReorderAction }>();

  onDelete() {
    this.delete.emit(this.action);
  }

  onReorder(action: any) {
    this.reorder.emit({
      id: this.action.id,
      action: action,
    });
  }
}
